import { z } from 'zod'

import { FilterType } from '@wwt/entities/api/filters'

const ActiveFilterChooseBase = z.object({
	id: z.string(),
	optionIDs: z.array(z.string())
})

const ActiveFilterChooseAnd = ActiveFilterChooseBase.extend({
	type: z.literal(FilterType.AND)
})

const ActiveFilterChooseOr = ActiveFilterChooseBase.extend({
	type: z.literal(FilterType.OR)
})

/**
 * Saved choose filter from user
 */
export const ActiveFilterChoose = z.discriminatedUnion('type', [
	ActiveFilterChooseAnd,
	ActiveFilterChooseOr
])

export type ActiveFilterChoose = z.infer<typeof ActiveFilterChoose>

const ActiveFilterRangeBase = z.object({
	id: z.string(),
	rangeLower: z.coerce.number(),
	rangeUpper: z.coerce.number(),
	defaultMin: z.coerce.number(),
	defaultMax: z.coerce.number()
})

const ActiveFilterRangeRange = ActiveFilterRangeBase.extend({
	type: z.literal(FilterType.RANGE)
})

const ActiveFilterPriceRange = ActiveFilterRangeBase.extend({
	type: z.literal(FilterType.PRICE_RANGE)
})

/**
 * Saved range filter from user
 */
export const ActiveFilterRange = z.discriminatedUnion('type', [
	ActiveFilterRangeRange,
	ActiveFilterPriceRange
])

export type ActiveFilterRange = z.infer<typeof ActiveFilterRange>

/**
 * Saved filter value from user
 *
 * If choose - array of checked options
 * If range - upper and lower range values
 */
export const ActiveFilter = z.discriminatedUnion('type', [
	...ActiveFilterChoose.options,
	...ActiveFilterRange.options
])

export type ActiveFilter = z.infer<typeof ActiveFilter>

/**
 * Type for send to API and save in URLSearchParams
 */
export const ActiveFilters = z.array(ActiveFilter)

export type ActiveFilters = z.infer<typeof ActiveFilters>

/**
 * Map of filters, {filterId: ActiveFilter}
 *
 * We can use it for easy access to active filter info without
 * find it in array
 */
export const ActiveFiltersMap = z.record(z.string(), ActiveFilter)

export type ActiveFiltersMap = z.infer<typeof ActiveFiltersMap>
